module.exports = "/_next/static/images/25-1-4ca8bbfa7b9dedb1fc43c0e4737c6287.svg";